import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@zep/utils';
const Root = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    children,
    ...rest
  } = props;
  return <div className={cn('flex w-full justify-center', className)} {...rest} data-sentry-component="Root" data-sentry-source-file="PlanPaymentLayout.tsx">
      {children}
    </div>;
};
const Content = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    children,
    ...rest
  } = props;
  return <div className={cn('flex size-full justify-center bg-gray-100', className)} {...rest} data-sentry-component="Content" data-sentry-source-file="PlanPaymentLayout.tsx">
      {children}
    </div>;
};
const Footer = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    children,
    ...rest
  } = props;
  return <div className={cn('fixed bottom-0 flex w-full items-center justify-center bg-white shadow-[0_4px_8px_3px_rgba(42,39,65,0.10)]', className)} {...rest} data-sentry-component="Footer" data-sentry-source-file="PlanPaymentLayout.tsx">
      {children}
    </div>;
};
export const PlanPaymentLayout = {
  Root,
  Content,
  Footer
};